import React from "react";
import { DashRevenueMetricCardSkeleton } from "./DashCardSkeletons";
import { AddCommas } from "../../../../config";
import { getAmount } from "../../../../utils/helper";

function formatTrendPct(pct) {
  if (pct == null || Number.isNaN(pct)) return "—";
  const abs = Math.abs(pct);
  const arrow = pct > 0 ? "↑" : pct < 0 ? "↓" : "→";
  return `${arrow}${abs.toFixed(2)}%`;
}

function formatDelta(trend, mode, currencySign) {
  if (trend?.delta == null || Number.isNaN(Number(trend.delta))) return null;
  if (mode === "currency") return getAmount(trend.delta, currencySign);
  if (mode === "count") return AddCommas(Math.round(trend.delta));
  if (mode === "percent") return `${trend.delta >= 0 ? "+" : ""}${trend.delta.toFixed(2)} pts`;
  if (mode === "rate") return `${Number(trend.delta).toFixed(2)}%`;
  return null;
}

/**
 * Compact KPI card for the revenue strip — no chart, Metronic-style layout.
 */
export default function DashRevenueMetricCard({
  accent = "slate",
  title,
  value,
  hint,
  trend,
  deltaMode = "count",
  currencySign = "₹",
  invertTrendColors = false,
  loading = false,
  onRemove,
}) {
  const pct = trend?.pct;
  const hasPct = pct != null && !Number.isNaN(Number(pct));
  const hasDelta = trend != null && trend.delta != null && Number.isFinite(Number(trend.delta));
  const showTrend = hasPct || hasDelta;

  const upGood = !invertTrendColors;
  const trendUp = hasPct && pct > 0;
  const trendDown = hasPct && pct < 0;
  const trendFlat = hasPct && pct === 0;

  let trendTone = "neutral";
  if (!trendFlat && hasPct) {
    const good = (trendUp && upGood) || (trendDown && !upGood);
    const bad = (trendUp && !upGood) || (trendDown && upGood);
    if (good) trendTone = "good";
    else if (bad) trendTone = "bad";
  }

  const deltaText = formatDelta(trend, deltaMode, currencySign);

  return (
    <div className={`acr-card acr-card--${accent}`}>
      {onRemove ? (
        <button
          type="button"
          className="acr-card__remove"
          aria-label={`Remove ${title}`}
          onClick={onRemove}
        >
          ×
        </button>
      ) : null}
      <div className="acr-card__inner">
        <div className="acr-card__accent" aria-hidden />
        <div className="acr-card__body">
          <div className="acr-card__label">{title}</div>
          {loading ? (
            <DashRevenueMetricCardSkeleton />
          ) : (
            <>
              <div className="acr-card__value">{value}</div>
              {hint ? <div className="acr-card__hint">{hint}</div> : null}
              {showTrend ? (
                <div className={`acr-card__trend acr-card__trend--${trendTone}`}>
                  <span className="acr-card__trend-pill">
                    {deltaText ? <span className="acr-card__trend-delta">{deltaText}</span> : null}
                    {hasPct ? <span className="acr-card__trend-pct">{formatTrendPct(pct)}</span> : null}
                  </span>
                  <span className="acr-card__trend-note">vs period</span>
                </div>
              ) : null}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
